import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getPasswordChangedPath = () => urlHelper('/password-recovery/password-changed');
